import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../../contexts/LanguageContext';
import { languageService } from '../../services/languageService';
import { FaTimes } from 'react-icons/fa';
import './LanguageSelector.css';

const LanguageSelector = () => {
  const { t } = useTranslation();
  const { selectedLanguage, changeLanguage, showLanguageModal, setShowLanguageModal } = useLanguage();
  const [languages, setLanguages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchLanguages();
  }, []);

  const fetchLanguages = async () => {
    try {
      const response = await languageService.getLanguages();
      setLanguages(response.data);
    } catch (error) {
      console.error('Error fetching languages:', error);
      // Fallback languages
      setLanguages([
        { code: 'en', name: 'English', nativeName: 'English' },
        { code: 'hi', name: 'Hindi', nativeName: 'हिंदी' },
        { code: 'ta', name: 'Tamil', nativeName: 'தமிழ்' }
      ]);
    } finally {
      setLoading(false);
    }
  };

  const handleLanguageSelect = (langCode) => {
    changeLanguage(langCode);
    setTimeout(() => {
      setShowLanguageModal(false);
    }, 200);
  };

  if (!showLanguageModal) return null;

  return (
    <div className="language-modal-overlay" onClick={() => setShowLanguageModal(false)}>
      <div className="language-modal" onClick={(e) => e.stopPropagation()}>
        <div className="language-modal-header">
          <h2>{t('select_language')}</h2>
          <button
            className="language-modal-close"
            onClick={() => setShowLanguageModal(false)}
            aria-label="Close"
          >
            <FaTimes />
          </button>
        </div>

        {loading ? (
          <div className="language-loading">
            <p>{t('loading')}</p>
          </div>
        ) : (
          <>
            <div className="language-grid">
              {languages
                .filter(lang => lang.code !== 'en')
                .map((lang) => (
                  <button
                    key={lang.code}
                    className={`language-option ${selectedLanguage === lang.code ? 'active' : ''}`}
                    onClick={() => handleLanguageSelect(lang.code)}
                  >
                    <div className="language-name">{lang.nativeName}</div>
                    <div className="language-subtitle">{lang.name}</div>
                  </button>
                ))}
            </div>
            {languages.find(lang => lang.code === 'en') && (
              <button
                className={`language-option language-option-full ${selectedLanguage === 'en' ? 'active' : ''}`}
                onClick={() => handleLanguageSelect('en')}
              >
                <div className="language-name">ENGLISH</div>
              </button>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default LanguageSelector;
